import React, { Component } from 'react';
import Query from './components/layout/Query';
import Result from './components/layout/Result';
import 'assets/css/App.css';
import 'assets/css/rwdLimit.css';
import injectTapEventPlugin from 'react-tap-event-plugin';
import {Route} from 'react-router';
import {HashRouter} from 'react-router-dom'
import { observer } from 'mobx-react'



try{
  injectTapEventPlugin()
}catch(err){

}

class App extends Component {
 

  render() {
    return (
      <div className="App">          
          <HashRouter> 
            <div className="router">
            <Route exact path="/" component={Query}/>   
            <Route path="/result" render={(props) => <Result {...props} />}/>     
            </div>                      
          </HashRouter>

      </div>
    );
  }
}

export default observer(App);



// WEBPACK FOOTER //
// ./src/App.js